// extracted by mini-css-extract-plugin
export var container = "HomeProductLinkContent-module--container--2ypqv";